import { Box, IconButton, SwipeableDrawer, useTheme } from '@mui/material';
import { cliengoQueries, useDisclosure } from '@cliengo/mfe-utils/hooks';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Flex } from '../utils';
import { PowerUserNavigation } from '../PowerUser/PowerUserNavigation';
import { BreadCrumbs } from '../BreadCrumbs/crumbs';

import { MenuIcon } from './Icons';
import { ProfileButton } from './profile-button/ProfileButton';
import { SupportButton } from './SupportButton';
import { useNavigationContext } from './Navigation';
import { NavItems } from './components/NavItems';
import { AffiliateButton } from './AffiliateButton';
import { FreeTrialBanner } from './FreeTrialBanner';

import { getLDClient } from '@/clients/launchDarklyClient';

export const TopBar = () => {
  const ldClient = getLDClient();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isSmall } = useNavigationContext();
  const { data: account } = cliengoQueries.account();
  const { data: user } = cliengoQueries.user();
  const { zIndex } = useTheme();
  const isFreeCompany = account?.planType.includes('FREE');

  const location = useLocation();

  useEffect(() => {
    if (isOpen) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <>
      <Flex
        sx={{
          background: 'white',
          height: '50px',
          width: isSmall ? '100%' : 'calc(100% - 60px)',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: isSmall ? 'static' : 'fixed',
          top: 0,
          left: isSmall ? '0' : '60px',
          borderBottom: '1px solid #e0e0e0',
          px: isSmall ? '1rem' : '25px',
          zIndex: zIndex.appBar,
        }}
      >
        {isSmall && (
          <IconButton onClick={onOpen} sx={{ padding: '4px' }}>
            <MenuIcon />
          </IconButton>
        )}
        {!isSmall && (
          <Flex>
            <BreadCrumbs />
          </Flex>
        )}
        <Flex alignItems="center" gap=".5rem">
          {user && 'isReferralUser' in user && (
            <AffiliateButton companyName={account.name} />
          )}
          {ldClient.evaluateFlag('experiment-power-user-navigation', false) && (
            <PowerUserNavigation />
          )}
          {isFreeCompany && (
            <Box sx={{ paddingLeft: '15px' }}>
              <FreeTrialBanner />
            </Box>
          )}
          <SupportButton />
          <ProfileButton />
        </Flex>
      </Flex>
      <SwipeableDrawer
        anchor="left"
        open={isOpen}
        onClose={onClose}
        onOpen={onOpen}
        swipeAreaWidth={20}
        disableBackdropTransition
        disableDiscovery={false}
        PaperProps={{
          sx: {
            borderRadius: '0 8px 8px 0',
          },
        }}
      >
        <Box
          sx={{
            '.nav-items-container': {
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '1rem',
            },
          }}
        >
          <NavItems account={account} />
        </Box>
      </SwipeableDrawer>
    </>
  );
};
